import { property } from "cosmos-config/generator";

const createFolderProperties = [property("Label", "label")];

export default createFolderProperties;
